module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2n6n9n-9db2558148f7780c39a025dc32e5278f.svg";